import React from 'react'
import { Link } from "react-router-dom";


const Physiotherapist = () => {
  return (
    <>
      <section className="page-title" style={{ backgroundImage: 'url(assets/images/background/3.jpg)' }}>
        <div className="auto-container">
          <h2>Physiotherapist</h2>
          <ul className="bread-crumb clearfix">
            <li><Link to="/">Home</Link></li>
            <li style={{ color: "green" }}>Physiotherapist</li>
          </ul>
        </div>
      </section>

      <div className="sidebar-page-container left-sidebar" style={{ marginTop: "-100px" }}>
        <div className="auto-container">
          <div className="row clearfix">
            {/* Sidebar Side */}
            <div className="sidebar-side col-lg-4 col-md-12 col-sm-12">
              <aside className="sidebar sticky-top">
                {/* Department Widget */}
                <div className="sidebar-widget department-widget">
                  <div className="widget-content">
                    <ul className="department-list">
                      <li className="active"><Link to="/physiotherapist">Physiotherapist</Link></li>
                      <li><Link to="/paediatrics">Paediatrics</Link></li>
                      <li ><Link to="/orthopedic">Orthopedic</Link></li>
                      <li ><Link to="/neurosurgery">Neurosurgery</Link></li>
                      <li ><Link to="/neurology">Neurology</Link></li>
                      <li ><Link to="/gynaecology">Gynaecology</Link></li>
                      <li><Link to="/general-surgery">General Surgery</Link></li>
                      <li><Link to="/general-medicine">General Medicine</Link></li>
                      <li ><Link to="/gastroenterology">Gastroenterology</Link></li>
                      <li ><Link to="/neuropsychiatrist">Neuropsychiatrist</Link></li>

                    </ul>
                  </div>
                </div>
                {/* Time Widget */}
                {/* <div className="sidebar-widget time-widget">
                  <div className="widget-content">
                    <div className="time-widget_content">
                      <span className="clock_icon flaticon-clock" />
                      <h4>Working Time</h4>
                      <ul className="working-time_list">
                        <li>Mon-Thu <span>08:00 - 20:00</span></li>
                        <li>Friday <span>07:00 - 22:00</span></li>
                        <li>Saturday <span>08:00 - 18:00</span></li>
                      </ul>
                    </div>
                  </div>
                </div> */}
                {/* Time Widget */}
                <div className="sidebar-widget contact-info_widget">
                  <div className="widget-content">
                    <div className="time-widget_content">
                      <h4>Contact Info</h4>
                      <ul className="contact-info_widget-list">
                        <li><span className="icon fa-solid fa-phone fa-fw" /><Link style={{ color: "black" }} to='https://share.google/fCIHbcmFHPs4QBm5t' target="_blank">सतना स्वास्तिक हॉस्पिटल पन्नीलाल चौक, सतना (म.प्र.)</Link></li>
                        <li><span className="icon fa-solid fa-envelope fa-fw" /> <Link style={{ color: "black" }} to="mailto:satnaswastikhospital@gmail.com">satnaswastikhospital@gmail.com</Link></li>
                        {/* <li><span className="icon fa-solid fa-clock fa-fw" />Mon - Sat 8:00 - 6:30, <br /> Sunday - CLOSED</li> */}
                      </ul>
                    </div>
                  </div>
                </div>
                {/* Expert Widget */}
                {/* <div className="sidebar-widget expert_widget" style={{ backgroundImage: 'url(assets/images/background/pattern-33.png)' }}>
                  <span className="color-layer" />
                  <h3>Experienced Team of Doctors, Nurses, and Staff</h3>
                  <Link to="/appointment" className="theme-btn btn-style-one">
                    <span className="btn-wrap">
                      <span className="text-one">Book Appointment</span>
                      <span className="text-two">Book Appointment</span>
                    </span>
                  </Link>
                  <div className="image">
                    <img src="assets/images/resource/doctor-1.png" alt />
                  </div>
                </div> */}
              </aside>
            </div>
            {/* Content Side */}
            <div className="content-side col-lg-8 col-md-12 col-sm-12">
              <div className="department-detail">
                <div className="inner-box">
                  <div className="image">
                    <img src="assets/img/Physiotherapis.png" alt />
                  </div>
                  <h3>Physiotherapist</h3>
                  <p> बीमारियों या दुर्घटनाओं से प्रभावित मरीज़ों के शरीर के काम और मूवमेंट को ठीक करना फिजियोथेरेपी और रिहैबिलिटेशन डिपार्टमेंट के दायरे में आता है। मरीज़ों की हालत को ज़्यादा से ज़्यादा बेहतर बनाने के लिए, यह डिपार्टमेंट नई टेक्नोलॉजी को फिजिकल एक्टिविटीज़ के साथ मिलाता है। हमारे बहुत काबिल और अनुभवी फिजियोथेरेपिस्ट के स्टाफ की वजह से आपको सबसे किफायती कीमत पर सबसे अच्छी देखभाल और सर्विस मिलेगी।</p>
                  <p>हमारे फिजियोथेरेपी और रिहैबिलिटेशन डिपार्टमेंट में आधुनिक रिहैबिलिटेशन उपकरण, जैसे कि ट्रेडमिल, साइकिल, एर्गोमीटर, मल्टीस्टेशन जिम, सीढ़ियाँ और रैंप, अच्छी तरह से मौजूद हैं। ये उपकरण मरीज़ों को दर्द से राहत दिलाने, मांसपेशियों का संतुलन बहाल करने और पोस्चर को ठीक करने में मदद करते हैं।</p>
                  <p>वृद्धावस्था फिजियोथेरेपी एक विशेष क्षेत्र है जो बढ़ती उम्र और स्वास्थ्य संबंधी जटिलताओं के कारण गति संबंधी विकारों से पीड़ित वृद्ध लोगों के आकलन और उपचार पर केंद्रित है।</p>
                  <p>वृद्ध वयस्कों को गतिशीलता, शक्ति और आत्मविश्वास बनाए रखने में फिजियोथेरेपी महत्वपूर्ण भूमिका निभाती है। व्यक्तिगत व्यायाम और निर्देशित देखभाल के माध्यम से, फिजियोथेरेपी वरिष्ठ नागरिकों को सक्रिय, दर्द-मुक्त और संतुष्ट जीवन जीने में सहायता करती है।</p>

                  <h3>Specialised in</h3>
                  <div className="graph-outer">
                    <div className="row clearfix">
                      <div className="column col-lg-6 col-md-12 col-sm-12">
                        <ul className="list">
                          <li>ज्वाइंट रिप्लेसमेंट के बाद</li>
                          <li> बुजुर्गों का पुनर्वास </li>
                          <li> बच्चों का पुनर्वास </li>
                          <li> मस्कुलोस्केलेटल विकार </li>
                          <li> ऑर्थो पुनर्वास </li>
                          <li> न्यूरो पुनर्वास </li>
                          <li> कपपिंग थेरेपी </li>
                          
                        </ul>
                      </div>
                      <div className="column col-lg-6 col-md-12 col-sm-12">
                        <ul className="list">
                          <li> काइन्सियोलॉजी टेप </li>
                          <li> ड्राई नीडल थेरेपी </li>
                          <li> TENS थेरेपी </li>
                          <li> IFT थेरेपी </li>
                          <li> UST थेरेपी </li>
                          <li> डीप हीट </li>
                          <li> आइस थेरेपी </li>
                        </ul>
                      </div>

                    </div>
                  </div>

                  <h3>Specialists</h3>
                 <div className=" col-lg-6 col-md-12 col-sm-12">
                    <div className="inner-box wow fadeInLeft animated" data-wow-delay="450ms" data-wow-duration="1500ms" style={{ visibility: 'visible', animationDuration: '1500ms', animationDelay: '450ms', animationName: 'fadeInLeft' }}>
                      <div className="image">
                        <img src="assets/img/Dr. Radhe shyam.webp" alt style={{ width: "200px", height: "200px", borderRadius: "100px" }} />
                      </div>
                      <div className="lower-content">
                        <div className="content">
                          <h5 style={{ textAlign: "justify", marginTop: "-22px" }}><a to="#" style={{ textAlign: "center" }}>Dr. Radhe Shyam</a></h5>
                          <div className="designation" style={{ textAlign: "justify" }}> Physiotherapist Specialist </div>


                        </div>
                        {/* <a to="#" className="plus-box flaticon-plus" /> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      {/* <section className="gallery-one " style={{marginTop:"-190px"}}>
        <div className="auto-container">
          <div className="mixitup-gallery">
            <div className="filter-list row clearfix" id="MixItUp319C7B">
              <div className="project-block mix all family pediatrics therapy laboratory col-lg-3 col-md-4 col-sm-12" style={{ display: 'inline-block' }}>
                <div className="inner-box">
                  <div className="image">
                    <img src="assets/img/Paediatrics_2.webp" alt />
                    <div className="overlay-box">
                      <div className="overlay-inner">
                        <div className="overlay-content">
                          <div className="icon-box">
                            <span className="icon icon-heart1" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
               <div className="project-block mix all family pediatrics therapy laboratory col-lg-3 col-md-4 col-sm-12" style={{ display: 'inline-block' }}>
                <div className="inner-box">
                  <div className="image">
                    <img src="assets/img/Paediatrics_4.webp" alt />
                    <div className="overlay-box">
                      <div className="overlay-inner">
                        <div className="overlay-content">
                          <div className="icon-box">
                            <span className="icon icon-heart1" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="project-block mix all family pediatrics therapy laboratory col-lg-3 col-md-4 col-sm-12" style={{ display: 'inline-block' }}>
                <div className="inner-box">
                  <div className="image">
                    <img src="assets/img/Paediatrics_1.webp" alt />
                    <div className="overlay-box">
                      <div className="overlay-inner">
                        <div className="overlay-content">
                          <div className="icon-box">
                            <span className="icon icon-heart1" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="project-block mix all family pediatrics therapy laboratory col-lg-3 col-md-4 col-sm-12" style={{ display: 'inline-block' }}>
                <div className="inner-box">
                  <div className="image">
                    <img src="assets/img/Paediatrics_3.webp" alt />
                    <div className="overlay-box">
                      <div className="overlay-inner">
                        <div className="overlay-content">
                          <div className="icon-box">
                            <span className="icon icon-heart1" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
             
              
             
            </div>
          </div>
        </div>
      </section> */}




    </>
  )
}

export default Physiotherapist